<div (keydown)="handleKeyPress($event)" tabindex="0" class="dialog-content">
  <!-- Card Container -->
  <div>
    <!-- Header -->
    <div class="dialog-content-header">
      <div class="header-text">
        <span style="margin-bottom: 20px;">
          <svg class="svg-icon" width="30" height="25" viewBox="0 0 25 25" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.5 21.3542C11.465 21.3542 10.5063 21.1033 9.62377 20.6016C8.74125 20.0999 8.0645 19.3959 7.59353 18.4896H5.25577C5.08082 18.4896 4.93237 18.4259 4.81041 18.2986C4.68844 18.1713 4.62746 18.0169 4.62746 17.8352C4.62746 17.6465 4.68934 17.4902 4.81309 17.3665C4.93684 17.2427 5.09308 17.1809 5.28181 17.1809H7.054C6.92001 16.7019 6.85045 16.2161 6.84533 15.7235C6.84022 15.231 6.83767 14.7383 6.83767 14.2455H5.24509C5.07015 14.2455 4.92169 14.1818 4.79973 14.0545C4.67775 13.9272 4.61676 13.7727 4.61676 13.5911C4.61676 13.4024 4.67864 13.2461 4.80239 13.1224C4.92614 12.9986 5.08239 12.9368 5.27113 12.9368H6.83767C6.83767 12.423 6.83867 11.9105 6.84067 11.3993C6.84266 10.888 6.92312 10.3891 7.08205 9.90253H5.25577C5.08082 9.90253 4.93237 9.83887 4.81041 9.71154C4.68844 9.58423 4.62746 9.42977 4.62746 9.24816C4.62746 9.05942 4.68934 8.90318 4.81309 8.77943C4.93684 8.65568 5.09308 8.59381 5.28181 8.59381H7.64293C7.89713 8.12327 8.21743 7.70915 8.60382 7.35146C8.99022 6.99379 9.42314 6.69832 9.90257 6.46506L8.38413 4.95196C8.26571 4.83444 8.21084 4.69255 8.21952 4.52628C8.2282 4.36003 8.29175 4.21993 8.41017 4.10597C8.52857 3.98755 8.67413 3.92834 8.84684 3.92834C9.01956 3.92834 9.16513 3.98755 9.28353 4.10597L11.1686 5.9843C11.6146 5.84097 12.0642 5.7693 12.5174 5.7693C12.9705 5.7693 13.4201 5.84097 13.8662 5.9843L15.796 4.07993C15.9179 3.96151 16.0609 3.90664 16.225 3.91532C16.389 3.924 16.5302 3.98755 16.6486 4.10597C16.767 4.21993 16.8262 4.36437 16.8262 4.5393C16.8262 4.71425 16.767 4.86093 16.6486 4.97933L15.1629 6.46506C15.6423 6.69832 16.0672 6.9958 16.4376 7.35748C16.808 7.71918 17.1274 8.13129 17.3958 8.59381H19.7549C19.9299 8.59381 20.0783 8.65746 20.2003 8.78477C20.3223 8.91208 20.3833 9.06654 20.3833 9.24816C20.3833 9.43691 20.3214 9.59316 20.1976 9.71691C20.0739 9.84066 19.9176 9.90253 19.7289 9.90253H17.918C18.0885 10.3891 18.17 10.888 18.1627 11.3993C18.1554 11.9105 18.1517 12.423 18.1517 12.9368H19.7549C19.9299 12.9368 20.0783 13.0015 20.2003 13.131C20.3223 13.2606 20.3833 13.4139 20.3833 13.5911C20.3833 13.7799 20.3214 13.9361 20.1976 14.0599C20.0739 14.1836 19.9176 14.2455 19.7289 14.2455H18.1517C18.1517 14.7383 18.1509 15.231 18.1493 15.7235C18.1478 16.2161 18.08 16.7019 17.946 17.1809H19.7549C19.9299 17.1809 20.0783 17.2445 20.2003 17.3718C20.3223 17.4992 20.3833 17.6536 20.3833 17.8352C20.3833 18.024 20.3214 18.1802 20.1976 18.304C20.0739 18.4277 19.9176 18.4896 19.7289 18.4896H17.4172C16.9533 19.4075 16.2784 20.1144 15.3923 20.6103C14.5062 21.1062 13.5421 21.3542 12.5 21.3542ZM12.5 20.0454C13.6975 20.0454 14.7207 19.6228 15.5696 18.7774C16.4185 17.9321 16.843 16.9106 16.843 15.7132V11.4584C16.843 10.2609 16.4185 9.23949 15.5696 8.39412C14.7207 7.54877 13.6975 7.1261 12.5 7.1261C11.3025 7.1261 10.2794 7.54877 9.43043 8.39412C8.58153 9.23949 8.15707 10.2609 8.15707 11.4584V15.7132C8.15707 16.9106 8.58153 17.9321 9.43043 18.7774C10.2794 19.6228 11.3025 20.0454 12.5 20.0454ZM11.2313 16.4063H13.7948C13.9697 16.4063 14.1182 16.3444 14.2401 16.2206C14.3621 16.0969 14.4231 15.9406 14.4231 15.7519C14.4231 15.5632 14.3612 15.4069 14.2375 15.2832C14.1137 15.1594 13.9575 15.0975 13.7687 15.0975H11.2053C11.0303 15.0975 10.8819 15.1594 10.7599 15.2832C10.6379 15.4069 10.5769 15.5632 10.5769 15.7519C10.5769 15.9406 10.6388 16.0969 10.7626 16.2206C10.8863 16.3444 11.0426 16.4063 11.2313 16.4063ZM11.2313 12.074H13.7948C13.9697 12.074 14.1182 12.0121 14.2401 11.8884C14.3621 11.7646 14.4231 11.6084 14.4231 11.4196C14.4231 11.2309 14.3612 11.0746 14.2375 10.9509C14.1137 10.8271 13.9575 10.7653 13.7687 10.7653H11.2053C11.0303 10.7653 10.8819 10.8271 10.7599 10.9509C10.6379 11.0746 10.5769 11.2309 10.5769 11.4196C10.5769 11.6084 10.6388 11.7646 10.7626 11.8884C10.8863 12.0121 11.0426 12.074 11.2313 12.074Z"
              fill="url(#paint0_linear_14_334)" />
            <defs>
              <linearGradient id="paint0_linear_14_334" x1="5.31248" y1="3.75003" x2="20.625" y2="23.75"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#B92076" />
                <stop offset="0.958333" stop-color="#0036AC" />
              </linearGradient>
            </defs>
          </svg>
        </span>
        <span class="ml-2">View {{issue?.selectedIssue}}</span>
      </div>
      <button class="close-box" (click)="closeDialog()">
        <img src="assets/icons/dashboard-icons/close-pink-icon.svg" alt="Close" class="close-box-img">
      </button>
    </div>

    <!-- Scrollable Content -->
    <div class="dialog-content-content">
      <div class="row">
        <!-- Issue Badge -->
        <div class="col-md-3">
          <div class="dialog-content-details-title">
            {{ issue?.selectedIssue }} Id
          </div>
          <div [style]="getIssueBadgeStyle(issue?.selectedIssue)">{{ issue?.bugId }}</div>
        </div>
        <div class="col-md-3">
          <div class="dialog-content-details-title">Raised By</div>
          <div class="dialog-content-details-content">{{ issue.createdByName}}</div>
        </div>
        <div class="col-md-3">
          <div class="dialog-content-details-title">Status</div>
          <div [style.color]="issue?.status ? '#4CAF50' : '#333'" class="dialog-content-details-content">{{
            issue?.status ? 'Closed' : 'Open' }}</div>
        </div>
        <div class="dialog-content-images col-md-3">
          <div class="dialog-content-details-title">Images</div>
          <div (click)="openImage(issue)" class="dialog-content-resource-image-div">
            <span class="dialog-content-resource-image-div-text">Click to view attachments</span>
          </div>
        </div>
      </div>
      <!-- Issue Details -->
      <div class="dialog-content-details">
        <div class="dialog-content-details-content">
          <div class="dialog-content-details-title">Title</div>
          <div class="dialog-content-details-content">{{ issue?.shortSummary }}</div>
        </div>
        <div class="dialog-content-details-content">
          <div class="dialog-content-details-title">Description</div>
          <div class="dialog-content-details-content">{{ issue?.descriptiveSummary }}</div>
        </div>
      </div>

      <!-- Stage Progress and Images -->
      <div class="dialog-stage-and-image">
        <!-- Stage Progress -->
        <div class="dialog-content-stage">
          <div class="dialog-content-details-title">Stage Progress</div>
          <div class="dialog-content-stage-div">
            <ng-container *ngFor="let stage of getStagesForProgress(issue); let i = index">
              <div [style.background]="getStages(issue).indexOf(issue.stage) >= i ? '#0036ac' : '#e0e0e0'"
                [style.color]="getStages(issue).indexOf(issue.stage) >= i ? 'white' : '#333'"
                class="dialog-content-stage-div-display">
                {{ stage | underScoreToSpace }}
              </div>
              <div *ngIf="i < getStagesForProgress(issue).length - 1" class="dialog-content-stage-div-selected">→</div>
            </ng-container>
          </div>
        </div>
        <!-- Stage Update -->
        <div *ngIf="hasManagerRights" style="display: flex; justify-content: flex-start;margin-top: 10px;"
          class="dialog-content-images">
          <mat-form-field appearance="outline" style="margin-top: 5px;width: 50%;">
            <mat-label class="dialog-content-details-title">Update Stage</mat-label>
            <mat-select [(ngModel)]="updateStageSearch" (selectionChange)="updateStage(issue)" style="font-size: 13px;">
              <mat-option *ngFor="let stage of getStages(issue)" [value]="stage" style="font-size: 13px;">
                {{ stage | underScoreToSpace }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>


      <!-- Developer Section -->
      <div *ngIf="hasDeveloperRights" class="dialog-content-developer mt-4">
        <div style="margin-bottom: 12px;height: 50px;">
          <div class="dialog-content-details-title">Trello Link</div>
          <a [href]="issue?.treeloLink" target="_blank" rel="noopener" class="dialog-content-developer-link">{{
            issue?.treeloLink }}</a>
        </div>
        <div style="margin-bottom: 12px;">
          <div class="dialog-content-details-title">Update Trello Link</div>
          <input type="text" [(ngModel)]="issue.treeloLink" placeholder="Enter URL"
            class="dialog-content-developer-link-update">
        </div>
        <div style="margin-bottom: 12px;">
          <div class="dialog-content-details-title">Additional Info</div>
          <textarea [(ngModel)]="issue.additionalInfo" placeholder="Enter details"
            class="dialog-content-developer-info"></textarea>
        </div>
      </div>

      <!-- Resource Section -->
      <div class="dialog-content-resource mt-2">
        <div *ngIf="hasResourceAccessRights" style="margin-bottom: 12px;">
          <div class="dialog-content-details-title">PNT Comments</div>
          <textarea [(ngModel)]="issue.pntComments" placeholder="Enter comments"
            class="dialog-content-resource-pnt"></textarea>
        </div>
      </div>
    </div>

    <!-- Footer Buttons -->
    <div class="dialog-content-footer">
      <button *ngIf="hasResourceAccessRights" (click)="updateInfo(issue)" class="dialog-content-footer-button">
        Update
      </button>
      <button *ngIf="hasManagerRights" (click)="notify(issue)" class="dialog-content-footer-button">
        Notify All
      </button>
    </div>
  </div>
</div>
